// ▶ Deixa uma tela FUNDA avisar o botão Voltar (que mora no Layout, fora
// dela) que há edição em aberto. Até 03/09/2026 só o botão "Cancelar" de
// dentro da ficha do produto perguntava "Descartar as alterações não
// salvas?" -- quem tocasse na seta ao lado do "CRM Multimarca" perdia o que
// tinha digitado sem aviso nenhum. Achado dela no 2º teste real, 03/09.
//
// Um slot só, e não uma lista: só existe UMA tela funda montada por vez, e
// React monta o efeito da nova antes de desmontar o da velha -- por isso
// registrar de novo SUBSTITUI, não empilha.
//
// Assincrona desde 24/09: a pergunta agora e a janela PROPRIA do app
// (confirmar.ts), que espera o toque -- a do celular travava a tela e devolvia
// na hora.
type Guarda = () => boolean | Promise<boolean>
let confirmarSaida: Guarda | null = null

export function registrarGuardaDeSaida(confirmar: Guarda): () => void {
  confirmarSaida = confirmar
  return () => {
    // ⚠ So limpa se a guarda ainda for a MESMA: se a tela nova ja registrou a
    // dela antes de a velha desmontar, a limpeza da velha nao pode apagar a
    // guarda da nova.
    if (confirmarSaida === confirmar) confirmarSaida = null
  }
}

export async function podeSair(): Promise<boolean> {
  return confirmarSaida === null || (await confirmarSaida())
}

// Fix round 1 do Task 13: so a seta do Layout consultava a guarda. Um <Link>
// comum dentro de uma tela funda (ex.: o link "Percentuais por
// produto/linha" no card de comissao, ou o nome da tabela em "Tabelas de
// preco") navegava direto e descartava rascunho pendente em silencio -- o
// mesmo buraco que a seta ja tapou em 03/09, so que por outra porta.
//
// Plain function (sem hook): quem chama passa a `navegar` que ja tirou do
// proprio `useNavigate()` e o destino; o `onClick` do Link so entrega o
// evento. Testavel sem DOM.
//
// `antesDeNavegar` (Task 16, escolha dela em 25/09): os dois links guardados
// que vivem dentro da Politica Comercial (percentuais e tabela de preco)
// trocam o historico por `?aba=comercial` ANTES de empilhar o destino, para a
// seta Voltar do cabecalho tambem pousar na Politica Comercial -- so roda
// quando a guarda deixa sair, e sempre antes do `navegar(to)`. Opcional e por
// ultimo de proposito: quem nao passa nada mantem o comportamento de sempre.
export function aoClicarComGuarda(
  navegar: (to: string, opcoes?: { replace?: boolean }) => void,
  to: string,
  antesDeNavegar?: () => void,
) {
  return (e: { preventDefault: () => void }) => {
    e.preventDefault()
    void podeSair().then((pode) => {
      if (!pode) return
      antesDeNavegar?.()
      navegar(to)
    })
  }
}
